import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../app/stores/rootStore';

const InventoryManager = observer(() => {
    const { productsStore } = useStore();
    const [searchTerm, setSearchTerm] = useState('');

    // Inline update handlers
    const handleQuickUpdate = async (productId: string, field: string, value: string | number) => {
        await productsStore.update(productId, { [field]: value });
    };

    // const filteredProducts = productsStore.items.filter(p => 
    //     p.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
    //     p?.toLowerCase().includes(searchTerm.toLowerCase())
    // );
    const filteredProducts = productsStore.items.filter(p => {
        const search = searchTerm.toLowerCase();

        // Safety check: ensure properties exist before calling toLowerCase()
        return (
            (p.title?.toLowerCase()?.includes(search)) ||
            (p.name?.toLowerCase()?.includes(search)) ||
            (p.brand?.toLowerCase()?.includes(search)) ||
            (p.id?.toLowerCase()?.includes(search))
        );
    });


    return (
        <div className="inventory-manager">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="fw-bold mb-0">Product Inventory</h4>
                <div className="d-flex gap-2">
                    <input 
                        type="text" 
                        className="form-control form-control-sm border-0 shadow-sm px-3" 
                        placeholder="Search products..." 
                        style={{ width: '250px', borderRadius: '10px' }}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button className="btn btn-primary btn-sm rounded-3 shadow-sm">
                        <i className="bi bi-plus-lg me-1"></i> New Product
                    </button>
                </div>
            </div>

            <div className="table-responsive">
                <table className="table align-middle table-hover">
                    <thead className="table-light">
                        <tr className="small text-uppercase text-muted">
                            <th style={{ width: '80px' }}>Image</th>
                            <th>Product Details</th>
                            <th>Category</th>
                            <th style={{ width: '150px' }}>Price (Rs.)</th>
                            <th style={{ width: '120px' }}>Stock</th>
                            <th>Status</th>
                            <th className="text-end">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredProducts.map(product => (
                            <tr key={product.id}>
                                <td>
                                    <img 
                                        src={product.mainImageUrl} 
                                        alt="" 
                                        className="rounded-3 shadow-sm" 
                                        style={{ width: '50px', height: '50px', objectFit: 'cover' }} 
                                    />
                                </td>
                                <td>
                                    <div className="fw-bold text-dark">{product.title}</div>
                                    <div className="text-muted extra-small">ID: {product.id?.slice(0, 8)}</div>
                                </td>
                                <td><span className="badge bg-secondary-subtle text-secondary">{product.categoryId}</span></td>
                                <td>
                                    <input 
                                        type="number" 
                                        className="form-control form-control-sm border-0 bg-light fw-bold"
                                        defaultValue={product.productPrice}
                                        onBlur={(e) => handleQuickUpdate(product.id!, 'productPrice', Number(e.target.value))}
                                    />
                                </td>
                                <td>
                                    <input 
                                        type="number" 
                                        className="form-control form-control-sm border-0 bg-light"
                                        defaultValue={product.stock}
                                        onBlur={(e) => handleQuickUpdate(product.id!, 'stock', Number(e.target.value))}
                                    />
                                </td>
                                <td>
                                    {product.stock <= 5 ? (
                                        <span className="badge rounded-pill bg-danger-subtle text-danger">Low Stock</span>
                                    ) : (
                                        <span className="badge rounded-pill bg-success-subtle text-success">In Stock</span>
                                    )}
                                </td>
                                <td className="text-end">
                                    <div className="btn-group">
                                        <button className="btn btn-sm btn-outline-primary border-0"><i className="bi bi-pencil-square"></i></button>
                                        <button className="btn btn-sm btn-outline-danger border-0" onClick={() => productsStore.delete(product.id!)}><i className="bi bi-trash"></i></button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {filteredProducts.length === 0 && <div className="text-center py-5 text-muted">No products found matching your search.</div>}
        </div>
    );
});

export default InventoryManager;